export const allCatagoryMenu= [
    {
        id: 1,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/6d462f424a43372ea8b7b6f8ca13e052.png",
        catagory:"Covid Essentials",
        offer: 77
    },
    {
        id: 2,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/b4a3a67a59783e0ca738884c9acc8e7b.png",
        catagory:"Personal Care",
        offer: 80
    },
    {
        id: 3,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/62e6d7551ecf3a5da1d2336c41cc0549.png",
        catagory:"Health Food and Drinks",
        offer: 57
    },
    {
        id: 4,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/ff5aaa03881e3016bf409f85b4e328aa.png",
        catagory:"Skin Care",
        offer: 50
    },
    {
        id: 5,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/68ae87e29f4a3abbb8ed69fe7ecf057c.png",
        catagory:"Home Care",
        offer: 35
    },
    {
        id: 6,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/4209e1d247cd30fca1f619786fa3e9c1.png",
        catagory:"Ayurvedic Care",
        offer: 70
    },
    {
        id: 7,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/7e509ee2f5413b0483d00c0b30067ee0.png",
        catagory:"Sexual Wellness",
        offer: 53
    },
    {
        id: 8,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/0e9613b95131376b95bcbf92c48149b5.png",
        catagory:"Fitness and Wellness",
        offer: 80
    },
    {
        id: 9,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/af8d32e30757338787ca3e9267865d4f.png",
        catagory:"Mother and Baby Care",
        offer: 50
    },
    {
        id: 10,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/e17c6d96de443b65988f5b2366b6ebb1.png",
        catagory:"Health Devices",
        offer: 65
    },
    {
        id: 11,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/2e58770425cc39a983d6d71fb0cc07e2.png",
        catagory:"Surgicals and Dressings",
        offer: 55
    },
    {
        id: 12,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/14bac4e33b11338299d8d6c1d905ca8f.png",
        catagory:"Health Conditons",
        offer: 65
    },
    {
        id: 13,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/ec716b08ac643f88971944792e2c5549.png",
        catagory:"Diabetic Care",
        offer: 65
    },
    {
        id: 14,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/292b08b6deab3ba9bd76d3a6ed4d71e0.png",
        catagory:"Elderly Care",
        offer: 45
    },
    {
        id: 15,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/236fc993bd00381fb7061ee2333ad0e3.png",
        catagory:"Accessories and Wearables",
        offer: 35
    },
    {
        id:16,
        img:"https://cdn01.pharmeasy.in/dam/discovery/categoryImages/71b097ea6a1e30b09efa6e2dd4e85cd5.jpg",
        catagory:"Beauty",
        offer: 10
    },
]